var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg04N(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9962 22.555H10.186C7.60386 22.555 6.11768 20.9028 6.11768 18.8603C6.11768 17.0918 7.23854 15.6969 8.89909 15.2237C9.18969 11.9109 11.913 9.41177 15.1344 9.41177C17.6004 9.41177 19.6262 10.7485 20.7305 12.9404C23.7444 12.9404 25.9612 14.9995 25.9612 17.7311C25.9612 20.4378 23.7942 22.555 20.9962 22.555Z",
    fill: "url(#paint0_linear_10214_639)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_10214_639)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5259 23.7647H13.4251C11.2512 23.7647 10 22.3745 10 20.6559C10 19.1679 10.9436 17.9943 12.3416 17.5961C12.5863 14.8087 14.879 12.7059 17.591 12.7059C19.667 12.7059 21.3726 13.8306 22.3022 15.6749C24.8396 15.6749 26.7059 17.4074 26.7059 19.7058C26.7059 21.9833 24.8815 23.7647 22.5259 23.7647Z",
    fill: "url(#paint1_linear_10214_639)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9674 15.8437L22.0713 16.0499H22.3022C24.6628 16.0499 26.3309 17.6437 26.3309 19.7058C26.3309 21.7664 24.6843 23.3897 22.5259 23.3897H13.4251C12.4199 23.3897 11.6618 23.0698 11.1573 22.5845C10.6525 22.0988 10.375 21.4222 10.375 20.6559C10.375 19.3437 11.1994 18.3113 12.4443 17.9567L12.6926 17.886L12.7152 17.6289C12.9432 15.031 15.0774 13.0809 17.591 13.0809C19.5162 13.0809 21.0972 14.1174 21.9674 15.8437Z",
    stroke: "url(#paint2_linear_10214_639)",
    strokeWidth: 0.75
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_10214_639",
    x: -10,
    y: -7.29413,
    width: 56.7058,
    height: 51.0588,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_10214_639"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_10214_639",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10214_639",
    x1: 11.8418,
    y1: 12.2869,
    x2: 25.2529,
    y2: 19.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B8B8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55248,
    stopColor: "#B7B7B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10214_639",
    x1: 18.3529,
    y1: 12.7059,
    x2: 18.3529,
    y2: 23.7647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222222"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10214_639",
    x1: 10,
    y1: 12.7059,
    x2: 26.7059,
    y2: 23.7647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644134,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg04N);
export default __webpack_public_path__ + "static/media/04n.c8b36ed5e4fbc98d9c7b33d9b9956600.svg";
export { ForwardRef as ReactComponent };